import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";

export default function WaiverDisabled({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const returnToServices = () => {
        if (loading) return;

        setError("");
        ///setStep(STEPS.SERVICE);
    };

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-header">

                <h2 className="business-name">
                    {flowContext.selectedService?.name
                        ? `${flowContext.selectedService.name} at ${flowContext.business?.businessName}`
                        : flowContext.business?.businessName}
                </h2>

            </div>

            <div className="page-content disabled-page">

                <div className="disabled-icon">
                    !
                </div>

                <h2 className="disabled-title">
                    Waiver Currently Unavailable
                </h2>

                <p className="disabled-text">
                    This waiver is temporarily unavailable and cannot
                    be completed at this time.
                </p>

                <p className="disabled-text">
                    This may be because the business subscription has
                    expired, the waiver has been disabled, or it is
                    currently unavailable.
                </p>

                <p className="disabled-text">
                    Please contact the business for assistance or try
                    again later.
                </p>

            </div>

            <div className="page-footer">

                <button
                    className="primary-button"
                    onClick={returnToServices}
                >
                    Return to Services
                </button>

            </div>

        </div>
    );
}